var module = angular.module('octopusApp.shared');

module.directive("onNewContent", function ($timeout) {

    function setNewContent($scope, name, data){
        $timeout(function () {
            setIsProcessing($scope, false);
            $scope.onNewContent({
                data: data,
                name: name
            });
        });
    }
    function setIsProcessing($scope, state) {
        $timeout(function () {
            $scope.isProcessing = state;
        });
    }
    function attachModernBrowserHandler($scope, element) {
        $(element).bind("change", function (changed) {
            setIsProcessing($scope, true);
            if (!changed.target.files || changed.target.files.length === 0 || !changed.target.files[0]) {
                setNewContent($scope);
                return;
            }

            var file = changed.target.files[0];
            if ($scope.encodeContent) {
                var reader = new FileReader();
                reader.onload = function (loaded) {
                    var b6 = loaded.target.result.indexOf('base64,') + 7;
                    setNewContent($scope, file.name, loaded.target.result.slice(b6));
                };

                reader.readAsDataURL(file);
            } else {
                setNewContent($scope, file.name);
            }
        });
    }

    function attachAncientBrowserHandler($scope, element) {
        window.FileAPI.event.on(element, 'change', function (ch) {
            setIsProcessing($scope, true);
            var files = window.FileAPI.getFiles(ch);
            if (files.length !== 1) {
                return setNewContent($scope);
            }
            var file = files[0];
            if ($scope.encodeContent) {
                window.FileAPI.readAsDataURL(file, function (rd) {
                    if (rd.type === 'load') {
                        var b6 = rd.result.indexOf('base64,') + 7;
                        setNewContent($scope, file.name, rd.result.slice(b6));
                    }
                });
            } else {
                setNewContent($scope, file.name);
            }
        });
    }

    return {
        scope: {
            onNewContent: "=",
            isProcessing: "=",
            encodeContent: "="
        },
        link: function ($scope, element, attr) {

            $scope.fileReaderAvailable = !!window.FileReader;
            if ($scope.fileReaderAvailable) {
                attachModernBrowserHandler($scope, element[0]);
            } else {
                attachAncientBrowserHandler($scope, element[0]);
            }
        }
    };
});

module.directive('sensitiveFileInput', function($compile) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/shared/views/sensitive_file_input.html',
        scope: {
            model: '=',
            display: '=',
            displayClass: '@'
        },
        link: function ($scope, $element) {
            var model;
            $scope.hasOriginalContent = false;
            $scope.hasNewContent = false;
            $scope.fileReaderAvailable = !!window.FileReader;
            $scope.onNewContent = changed;
            $scope.remove = remove;
            $scope.cancel = cancel;
            $scope.canCancel = false;
            setDisplay();

            function remove() {
                model.HasValue = false;
                model.NewValue = null;
                $scope.displayName = null;
                $scope.canCancel = $scope.hasOriginalContent;
                resetFileElements();
            }

            function changed(content) {
                if (!model) {
                    $scope.model = {};
                    link($scope.model);
                }
                if (content && content.data && content.data.length > 0) {
                    model.HasValue = true;
                    model.NewValue = content.data;
                    $scope.displayName = content.name;
                    $scope.hasNewContent = true;
                    $scope.canCancel = $scope.hasOriginalContent;
                } else {
                    remove();
                }
            }

            function resetFileElements() {
                $element.find('.uploader').each(function(index, uploader){
                    var $newUploader = $(uploader.outerHTML);
                    $compile($newUploader)($scope);
                    $(uploader).replaceWith($newUploader);
                });
            }

            function setDisplay(){
                $scope.displayName = $scope.display || 'A file exists.';
            }


            function cancel() {
                model.HasValue = true;
                model.NewValue = null;
                $scope.hasNewContent = false;
                $scope.canCancel = false;
                setDisplay();
            }


            function link(originalModel) {
                model = originalModel;
                $scope.hasOriginalContent = model.HasValue;
                $scope.canCancel = false;
            }

            if ($scope.model) {
                link($scope.model);
            } else {
                $scope.$watch('model', function(nv) {
                    if (nv && !$scope.view) {
                        link(nv);
                    }
                });
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/sensitive_file_input.js
// module id = 600
// module chunks = 1